import {
  GlobeAltIcon,
  LightningBoltIcon,
  ScaleIcon,
} from "@heroicons/react/outline";
import * as React from "react";
import CallToAction from "../templates/callToAction";
import FeatureItemLeftSide from "../templates/featureItemLeft";
import FeatureItemRightSide from "../templates/featureItemRightSide";
import FooterSection from "../templates/footer";
import NavBar from "../templates/navbar";
import TestimonialsSection from "../templates/testomonials";
import EmailImage from "./../images/channelsPage/email.png";
import FbImage from "./../images/channelsPage/fb.png";
import GoogleImage from "./../images/channelsPage/google.png";
import HeroImage from "./../images/channelsPage/hero-img.png";
import MobilePushImage from "./../images/channelsPage/mobile-push.png";
import PopupsImage from "./../images/channelsPage/popups.png";
import SmsImage from "./../images/channelsPage/sms.png";
import WebPushImage from "./../images/channelsPage/webpush.png";
import HerosectionSecondary from "./../templates/heroSecondarySection";
import { Helmet } from "react-helmet";

const info = {
  allFeatures: [
    {
      icon: GlobeAltIcon,
      title: "Segments Using Customer Attributes",
      description:
        "Segment customers based on attributes like average order value, total spent, total orders, city, gender, last activity time etc.",
    },
    {
      icon: LightningBoltIcon,
      title: "Segments Using Acquisition Sources",
      description:
        "Treat customer differently based on from which marketing channels and ads they came from like Facebook, Twitter, Youtube, Google Ad etc.",
    },
    {
      icon: ScaleIcon,
      title: "Segments Using Past Activities / Events",
      description:
        "Segment customers based on customers performing or not performing certain activities. Like customers who din't purchased this month but made purchases this year.",
    },
    {
      icon: ScaleIcon,
      title: "Segments Using Device Profiles",
      description:
        "Segment customers based on devices like Mobile, Desktop, Tablet etc. Segment them based on browser they are using while visiting your site.",
    },
    {
      icon: ScaleIcon,
      title: "Segments Using Location",
      description:
        "Segment customers based on geography like City, State, Country, Postal Code, Lattitude, Longitude etc.",
    },
    {
      icon: ScaleIcon,
      title: "Segments Using Channel Reachablity",
      description:
        "Segment customers based on whether they are reachable on email or SMS or WhatsApp or Push Notificaitons or  any other channels.",
    },
  ],
  emailFeatures: [
    {
      title: "Send contextual and targeted emails",
    },
    {
      title: "Increase open rates and conversions with personalized emails.",
    },
    {
      title:
        "Use pre-built templates and customize them to match your unique brand.",
    },
    {
      title: "Do more with segmentation and earlier campaign responses.",
    },
    {
      title: "Measure and improve email delivery rates.",
    },
  ],
  smsFeatures: [
    {
      title: "Send contextual and targeted emails",
    },
    {
      title:
        "Use pre-built templates and customize them to match your unique brand.",
    },
    {
      title: "Do more with segmentation and earlier campaign responses.",
    },
  ],
  webPushFeatures: [
    {
      title: "Send contextual and targeted emails",
    },
    {
      title:
        "Use pre-built templates and customize them to match your unique brand.",
    },
    {
      title: "Do more with segmentation and earlier campaign responses.",
    },
  ],
  whatsAppFeatures: [
    {
      title: "Send contextual and targeted emails",
    },
    {
      title:
        "Use pre-built templates and customize them to match your unique brand.",
    },
    {
      title: "Do more with segmentation and earlier campaign responses.",
    },
  ],
  mobilePushFeatures: [
    {
      title: "Send contextual and targeted emails",
    },
    {
      title:
        "Use pre-built templates and customize them to match your unique brand.",
    },
    {
      title: "Do more with segmentation and earlier campaign responses.",
    },
  ],
  inAppFeatures: [
    {
      title: "Send contextual and targeted emails",
    },
    {
      title:
        "Use pre-built templates and customize them to match your unique brand.",
    },
    {
      title: "Do more with segmentation and earlier campaign responses.",
    },
  ],
  onSiteFeatures: [
    {
      title: "Send contextual and targeted emails",
    },
    {
      title:
        "Use pre-built templates and customize them to match your unique brand.",
    },
    {
      title: "Do more with segmentation and earlier campaign responses.",
    },
  ],
  fbFeatures: [
    {
      title: "Send contextual and targeted emails",
    },
    {
      title:
        "Use pre-built templates and customize them to match your unique brand.",
    },
    {
      title: "Do more with segmentation and earlier campaign responses.",
    },
  ],
  googleAdsFeatures: [
    {
      title: "Send contextual and targeted emails",
    },
    {
      title:
        "Use pre-built templates and customize them to match your unique brand.",
    },
    {
      title: "Do more with segmentation and earlier campaign responses.",
    },
  ],
};

// markup
const IndexPage = () => {
  return (
    <main>
      <Helmet>
        <meta charset="utf-8" />
        <meta
          name="description"
          content="Reach-out customers on 6+ messaging channels"
        />
        <meta name="google" content="nositelinkssearchbox" />
        <title>6+ Marketing Channels</title>
        <link rel="canonical" href="/" />
      </Helmet>

      <NavBar></NavBar>

      {/* Hero Section */}
      <HerosectionSecondary
        image={HeroImage}
        title1="Reach-out customers on"
        title2="6+ messaging channels"
        description="Maximize your ROI by grouping your users and defining different  marketing strategies tailored to each segment."
        lightBackground={true}
      ></HerosectionSecondary>

      {/* Email Marketing Section */}
      <FeatureItemRightSide
        features={info.emailFeatures}
        image={EmailImage}
        badge="Email Marketing"
        title="Contextual & Personalized Emails"
        description=" Engage users with personalized emails at the right moment and increase your brand loyalty. Build beautiful emails using our templates and a drag & drop email editor."
      ></FeatureItemRightSide>

      {/* SMS Section */}
      <FeatureItemLeftSide
        features={info.smsFeatures}
        image={SmsImage}
        badge="SMS Messaging"
        title="Reach a offline customers with SMS messages"
        description="Use SMS to engage users offline with personalized and actionable messages. Personalize your SMS with user data to provide exceptional brand experience."
      ></FeatureItemLeftSide>

      {/* Web Push Section */}
      <FeatureItemRightSide
        features={info.webPushFeatures}
        image={WebPushImage}
        badge="Web Push Notifications"
        title="Re-target customers with web push notifications"
        description="Engage with users on desktop and mobile – even when they are not on your site. Use Growlytics’ data driven Web Push campaingns to create unique customer experiences."
      ></FeatureItemRightSide>

      {/* Facebook & Instagram Section */}
      <FeatureItemLeftSide
        features={info.fbFeatures}
        image={FbImage}
        badge="Facebook & Instagram Ads"
        title="Re-target customers with facebook and instagram ads"
        description=" Focus on delivering a more personalized experience without the need to re-create an audience in Facebook. Enhance Facebook targeting with the power of your customer data."
      ></FeatureItemLeftSide>

      {/* Google Ads Section */}
      <FeatureItemRightSide
        features={info.googleAdsFeatures}
        image={GoogleImage}
        badge="Google Ads"
        title="Re-target your customers with google ads"
        description="Sync your customer segments with your Google Ads account. Target your customers on google search, Shopping, Gmail, and Youtube."
      ></FeatureItemRightSide>

      {/* Popups Section */}
      <FeatureItemLeftSide
        features={info.onSiteFeatures}
        image={PopupsImage}
        badge="On-site Messages"
        title="Popups, Flyouts & Headers"
        description="Grow your email & SMS list with popups, flyouts, and other high-converting displays."
      ></FeatureItemLeftSide>

      {/* Mobile Push Section */}
      <FeatureItemRightSide
        features={info.onSiteFeatures}
        image={MobilePushImage}
        badge="Mobile Push Notifications"
        title="Send Personalized mobile push notifications"
        description="Reach users that are currently not in your app by delivering messages that attract your user’s attention and get them back into your app."
      ></FeatureItemRightSide>

      {/* Testimonials Section */}
      <TestimonialsSection></TestimonialsSection>

      {/* Call To Action */}
      <CallToAction></CallToAction>

      {/* Add Footer */}
      <FooterSection></FooterSection>
    </main>
  );
};

export default IndexPage;
